module.exports = __webpack_public_path__ + "assets/b31476f08754abb39a9e103b80275d68.png";